export default __webpack_public_path__ + "static/media/stack-books-library-desk (1).5b1345f2.jpg";